import { render, staticRenderFns } from "./projectClarifi.vue?vue&type=template&id=ce982384&scoped=true"
import script from "./projectClarifi.vue?vue&type=script&lang=js"
export * from "./projectClarifi.vue?vue&type=script&lang=js"
import style0 from "./projectClarifi.vue?vue&type=style&index=0&id=ce982384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce982384",
  null
  
)

export default component.exports